import { useEffect, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import {
  useGetItemDetailsDataMutation,
} from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import FileAttachmentManagerViewPage  from "../../../../Components/FileAttachmentManagerViewPage";
import Attachment from "../../../../utils/Attachment";
const ViewForm = () => {

   const location = useLocation();
      const IdData = location.state?.ItemId;
      const [podata, setpodata] = useState('')

    const navigate = useNavigate();
  const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

 
  // tab1
  const [Numeric_Values, setNumeric_Values] = useState(false);
  const [AttributeName, setAttributeName] =useState("");
  const [FromRange, setFromRange] =useState("");
  const [ToRange, setToRange] =useState("");
  const [Increment, setIncrement] =useState("");
const [selected_default_item_attribulte_data, setselected_default_item_attribulte_data] = useState([]);
  // console.log('tbl:',selected_default_item_attribulte_data)
  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
    Numeric_Values: false,
    AttributeName: false,
  });

const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();
const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
    useEffect(() => {
        if (IdData) {
            itemDetails({ doctype: 'Item Attribute', name: IdData })
                .unwrap()
                .then((response) => {
                   const item = response.docs?.[0]; // ✅ safely access first item
  const docinfo = response.docinfo;

  if (!item) return;
                    setpodata(response)
                    console.log(item, "Api response");
                    setNumeric_Values(item.numeric_values);
                    setAttributeName(item.attribute_name);
                    setFromRange(item.from_range);
                    setToRange(item.to_range)
                    setIncrement(item.increment)
                    setselected_default_item_attribulte_data(item.item_attribute_values)
                    setAttachmentsList(docinfo.attachments); // ✅ Correct place
                })
                .catch((err) => {
                    console.error('API Error:', err);
                });
        } else {
            console.warn('No Id Data found in location state');
        }
    }, [IdData, itemDetails]);
 

  
  return (
    <FormLayoutTwo
      title="View Item Attribute"
      breadcrumbs={[
        { label: "Item Attribute"},
        { label: "Item Attribute List", url: "/master/item-attribute/item-attribute-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
         <>
          {/* <Button
            to="/master/item-attribute/item-attribute-list"
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrFormPrevious"
            iconSize={12}
          >
            Back
          </Button> */}

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            <Attachment doctype="Item Attribute"  docname={IdData}  />    

          </div>
        </div>

           <div className=" " style={{ background: '' }}>
          <div className="row">
            <div className="col-12">
              <div >
                <Tab1
                   setselected_default_item_attribulte_data={setselected_default_item_attribulte_data}
                    selected_default_item_attribulte_data={selected_default_item_attribulte_data}
                    Numeric_Values={{
                      Numeric_Values: Numeric_Values,
                      setNumeric_Values: setNumeric_Values,
                      Numeric_Values: Numeric_Values,
                      Error: fieldErrors.Numeric_Values,
                    }}
                    AttributeName={{
                      AttributeName: AttributeName,
                      setAttributeName: setAttributeName,
                      AttributeName: AttributeName,
                      Error: fieldErrors.AttributeName,
                    }}
                    FromRange={{
                      FromRange: FromRange,
                      setFromRange: setFromRange,
                      FromRange: FromRange,
                      Error: fieldErrors.FromRange,
                    }}
                    ToRange={{
                      ToRange: ToRange,
                      setToRange: setToRange,
                      ToRange: ToRange,
                      Error: fieldErrors.ToRange,
                    }}
                    Increment={{
                      Increment: Increment,
                      setIncrement: setIncrement,
                      Increment: Increment,
                      Error: fieldErrors.Increment,
                    }}
                    
                  />
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayoutTwo>
  );
};

export default ViewForm;
